import { View } from "binder"
import { StopGroup, StopGroupManipulationViewModel } from "./stopGroupManipulation-viewModel"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";

export class StopGroupManipulationView extends View<StopGroupManipulationViewModel> {
    GetViewUniqueId(): string {
        return "V-64BAEEC5-3AEB-4BA3-AC31-8E4E6455FDF9"
    }
    loadHtml(): string {
        let element = require('./stopGroupManipulation.html').default;
        let style = require('./stopGroupManipulation.less');
        return element;
    }
    constructor() {
        super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set stopGroups(v: StopGroup) { this._stopGroups = v; } public get stopGroups(): StopGroup { return this._stopGroups; } private _stopGroups: StopGroup;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;

    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup; } private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup; } private _popup: IPopup;

    addNew() {
        this.dataContext.addNew();
    }
}
